import { IUser, USER_ROLE } from '../../Types/user';
import { getUserFromLS } from '../../utils/getUserFromLS';
import { TokenExpiration } from '../../utils/tokenExpiration';

export const emptyAuthUser: IUser = {
  id: '0',
  username: '',
  role: USER_ROLE.USER,
  name: null,
  email: null,
  full_name: '',
  access_token: '',
  client_id: null,
  client: null,
  linkedin_profile_url: null,
  disabled: false,
  last_seen_at: new Date(),
  auth_method: null,
  token_expires_at: new Date(),
  microsoft_id: null,
};

export function buildInitialAuthState() {
  const user = getUserFromLS();
  const hasStoredSession = Boolean(
    localStorage.getItem('user') && user?.access_token && user?.id
  );
  const sessionIsValid = hasStoredSession && !TokenExpiration.isTokenExpired();

  return {
    loading: sessionIsValid,
    isAuthenticated: sessionIsValid,
    token: sessionIsValid ? user.access_token : null,
    user: sessionIsValid ? user : emptyAuthUser,
    loginFailed: false,
    errorMessage: '',
  };
}
